<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-30 
-->
<template>
  <div class="main-container">
    <page-header>{{'个人信息' | dealLanguage('Account information')}}</page-header>
    <div class="flex-wrapper">
      <div class="flex-left">
        <user-info-nav></user-info-nav>
      </div>
      <div class="flex-right">
        <div class="form-view">
          <Form ref="current-form" :model="currentForm" :rules="ruleValidate">
            <div class="view-title">
              <div class="title">{{'账户信息' | dealLanguage('Account information')}}</div>
              <div class="line"></div>
            </div>
            <Row :gutter="26">
              <Col span="8">
              <FormItem prop="mobileAreaCode" :label="'国家地区码' | dealLanguage('Area Code')">
                <Input type="text" v-model="currentForm.mobileAreaCode" disabled></Input>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem prop="mobile" :label="'手机号码' | dealLanguage('Phone Number')">
                <Input type="text" v-model="currentForm.mobile" disabled></Input>
              </FormItem>
              </Col>
              <Col span="4">
              <Button @click="handleChangeMobile" type="primary" class="form-btn">{{'修改手机号' | dealLanguage('Modify')}}</Button>
              </Col>
            </Row>
            <div class="view-title">
              <div class="title">{{'身份信息' | dealLanguage('Identity information')}}</div>
              <div class="line"></div>
            </div>
            <FormItem prop="name" :label="'姓名' | dealLanguage('Name')">
              <Input type="text" v-model="currentForm.name" :placeholder="'请填写姓名' | dealLanguage('Please fill in your name')"></Input>
            </FormItem>
            <FormItem prop="compName" :label="'公司' | dealLanguage('Company')">
              <div class="input-tag">
                <AutoComplete v-model="entityKeyword" :placeholder="!currentForm.entityId ? filter.dealLanguage('请搜索并选择公司', 'Please search and select a company') : ''" @on-search="handleSearchEntity" @on-select="handleSelectEntity" @on-change="handleChangeEntity">
                  <Option v-for="item in entityList" :value="item.id" :key="item.id">
                    <div class="title">
                      {{item.shortName}}
                    </div>
                    <div class="desc">
                      {{item.description}}
                    </div>
                  </Option>
                </AutoComplete>
                <div class="tag-div" v-if="currentForm.entityId">
                  <Tag closable @on-close="handleClose" color="blue">{{currentForm.compName}}</Tag>
                </div>
              </div>
            </FormItem>
            <Row :gutter="26">
              <Col span="12">
              <FormItem prop="department" :label="'部门' | dealLanguage('Department')">
                <Input type="text" v-model="currentForm.department" :placeholder="'请填写部门' | dealLanguage('Please fill in the department')"></Input>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem prop="title" :label="'职位' | dealLanguage('Position')">
                <Input type="text" v-model="currentForm.title" :placeholder="'请填写职位' | dealLanguage('Please fill in the position')"></Input>
              </FormItem>
              </Col>
            </Row>
            <Row :gutter="26">
              <Col span="12">
              <FormItem prop="companyNatureId" :label="'请问贵公司性质' | dealLanguage('Company nature')">
                <treeselect v-model="currentForm.companyNatureId" :disableBranchNodes="true" :placeholder="'请选择' | dealLanguage('Please select')" :options="companyNatureTree" @input="handleChangeNT($event, 0)" />
              </FormItem>
              </Col>
              <Col span="12" v-if="compNTother">
              <FormItem prop="companyNatureOtherTagName" :label="'其他' | dealLanguage('Other')">
                <Input type="text" v-model="currentForm.companyNatureOtherTagName" :placeholder="'请填写具体性质' | dealLanguage('Please fill in the specific nature')"></Input>
              </FormItem>
              </Col>
            </Row>
          </Form>
          <div class="btn-wrapper">
            <Button type="primary" @click="handleSubmit" :loading="buttonLoading">
              <span v-if="buttonLoading">{{'保存中' | dealLanguage('Loading')}}</span>
              <span v-else>{{'保存' | dealLanguage('SAVE')}}</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
    <update-mobile ref="update-mobile" @updateMobileSuccess="updateMobileSuccess"></update-mobile>
  </div>
</template>
<script>
import { Auserinfo, Agetmeta } from '@/service/app'
import PageHeader from '@/components/pc/pageHeader.vue'
import UserInfoNav from '@/components/pc/userInfoNav.vue'
import UpdateMobile from '@/components/pc/updateMobile.vue'
import buildTree from 'js/buildTree'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { searchEntity } from 'js/searchEntity'
import filter from 'js/filter'
import { mapState } from 'vuex'
export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('个人信息', 'Account information'),
    }
  },
  mixins: [searchEntity],
  components: {
    PageHeader,
    UserInfoNav,
    UpdateMobile,
    Treeselect,
  },
  created() {
    this.currentForm = {
      name: this.user.name || '',
      compName: this.user.compName || '',
      entityId: this.user.entityId || 0,
      department: this.user.department || '',
      title: this.user.title || '',
      companyNatureId: this.user.companyNatureId || null,
      companyNatureOtherTagName: this.user.companyNatureOtherTagName || '',
    }
    this.updateMobileSuccess(this.user)
    this.entityKeyword = this.user.compName || ''
    this.Agetmeta()
  },
  mounted() {},
  data() {
    return {
      filter,
      buttonLoading: false,
      companyNatureTags: [],
      companyNatureTree: [],
      compNTother: '',
      currentForm: {
        name: '',
        mobileAreaCode: '',
        mobile: '',
        compName: '',
        entityId: 0,
        department: '',
        title: '',
        companyNatureOtherTagName: '',
        companyNatureId: null,
      },
      ruleValidate: {
        name: [{ required: true, message: filter.dealLanguage('请填写姓名', 'Please fill in your name'), trigger: 'blur' }],
        compName: [{ required: true, message: filter.dealLanguage('请搜索并选择公司', 'Please search and select a company'), trigger: 'change' }],
        department: [{ required: true, message: filter.dealLanguage('请填写部门', 'Please fill in the department'), trigger: 'blur' }],
        title: [{ required: true, message: filter.dealLanguage('请填写职位', 'Please fill in the position'), trigger: 'blur' }],
        companyNatureId: [
          { required: true, type: 'number', message: filter.dealLanguage('请选择公司性质', 'Please select'), trigger: 'change' },
        ],
        companyNatureOtherTagName: [
          { required: true, message: filter.dealLanguage('请填写具体性质', 'Please fill in the specific nature'), trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      language: (state) => state.language,
    }),
  },
  methods: {
    async Agetmeta() {
      let res = await Agetmeta({
        metaNameList: ['companyNatureTags'],
      })
      if (res.code != 0) return
      this.$set(this.$data, 'companyNatureTags', res.data.companyNatureTags)
      res.data.companyNatureTags.forEach((tag) => {
        tag.label = filter.dealLanguage(tag.name, tag.enName)
      })
      const tree = buildTree(res.data.companyNatureTags)
      this.companyNatureTree = [...tree]
      this.handleChangeNT(this.currentForm.companyNatureId, 1)
    },
    handleChangeNT(value, isfirst = 0) {
      if (!isfirst) this.currentForm.companyNatureOtherTagName = ''
      if (!value) {
        this.compNTother = ''
        return
      }
      let item = this.companyNatureTags.find((a) => a.id === value)
      if (item.name.indexOf('其他') > -1 || item.name.indexOf('Other') > -1 || item.name.indexOf('other') > -1) {
        this.compNTother = item.name
      } else {
        this.compNTother = ''
      }
    },
    
    handleChangeMobile() {
      this.$refs['update-mobile'].modelIndex = true
    },
    handleSubmit() {
      if (this.buttonLoading) return
      this.$refs['current-form'].validate(async (valid) => {
        if (valid) {
          this.buttonLoading = true
          let { mobile, mobileAreaCode, ...params } = this.currentForm
          let res = await Auserinfo(params)
          this.buttonLoading = false
          if (res.code == 0) {
            let user = { ...this.user }
            user.name = this.currentForm.name
            user.compName = this.currentForm.compName
            user.department = this.currentForm.department
            user.title = this.currentForm.title
            user.entityId = this.currentForm.entityId
            user.companyNatureId = this.currentForm.companyNatureId
            user.companyNatureOtherTagName = this.currentForm.companyNatureOtherTagName
            this.$store.commit('updateUser', user)
            this.$Message.success(this.language == 'zh' ? '保存成功！' : 'Save successfully!')
          }
        }
      })
    },
    updateMobileSuccess(user) {
      this.currentForm.mobile = user.mobile
      if (user.mobileAreaCode) {
        this.currentForm.mobileAreaCode = `+${user.mobileAreaCode} ${filter.deal(
          user.mobileAreaCode,
          'appMobileAreaCodeDtos',
          'mobileAreaCode',
          'countryName'
        )}`
      }
      this.$forceUpdate()
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
@import '~styles/form-view.styl'
.form-view
  padding-bottom 30px
.flex-right
  padding-right 120px
  .btn-wrapper
    margin-top 14px
    text-align center
  .form-btn
    color #fff
    background-color #C8161D
    border-color #C8161D
    box-shadow none
    transition all 0.3s
    width 100%
    height 40px
    font-size 16px
    margin-top 24px
    &:hover
      background-color #E24147
      border-color #E24147
</style>